
















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import termCondiction from "@/models/termCondiction/termCondictioModel";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";

@Component
export default class TermCondictionsAdd extends GenericBTable<termCondiction> {

  created() {
    this.permissionValue = PermissionValue.TERMINOSCONDICIONES;
    this.tableConfig.controller = "TermCondictions";
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let title = new BTableColumn("title", "table.title", true);
    this.tableConfig.insertColumns(title);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
}
